import { FaHome, FaRegFrownOpen } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

function NotFound() {
    const { hasRole } = useAuth();
    const isAdmin = hasRole && hasRole('ADMIN');
    return (
      <div className='hero'>
        <div className='text-center hero-content'>
          <div className='max-w-lg'>
              <h1 className='text-8xl font-bold mb-8 flex justify-center'><FaRegFrownOpen /></h1>
              <p className='text-5xl mb-8'>Missed your way?</p>
              <Link to={isAdmin ? '/admin' : '/'} className='btn btn-primary btn-ghost btn-lg bg-gray-700 text-white border-none'>
                  <FaHome className='mr-2' />Find Your Way Back Home
              </Link>
          </div>
        </div>
      </div>
    )
}

export default NotFound
